import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=5cb0b2bc&"
import script from "./confirm.vue?vue&type=script&lang=ts&"
export * from "./confirm.vue?vue&type=script&lang=ts&"
import style0 from "./confirm.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports